module.exports = __webpack_public_path__ + "img/pdf.ad56a6ba.png";